import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    roomId: String,
    isUnread: Boolean
  };

  connect() {
    document.dispatchEvent(
      new CustomEvent('room:marked-unread', {
        detail: {
          roomId: this.roomIdValue,
          isUnread: this.isUnreadValue
        }
      })
    );

    this.element.remove();
  }
}